/* etq-card-swatches.js
   Desktop: hover a colour dot → preview that variant image; leaving the
   swatch row reverts to the original image.
   Mobile/touch: tap a dot → swap and lock to that variant image.
   Scoped per card; dots without a data-variant-image do nothing. */
(function () {
  'use strict';

  function findCardImages(swatchList) {
    var card = swatchList.closest('.card') || swatchList.closest('.card-wrapper');
    if (!card) return [];
    var imgs = card.querySelectorAll('.card__media img, .media img');
    return Array.prototype.slice.call(imgs);
  }

  function stashOriginal(img) {
    if (!img.dataset.etqOrigSrc) {
      img.dataset.etqOrigSrc = img.getAttribute('src') || '';
      img.dataset.etqOrigSrcset = img.getAttribute('srcset') || '';
      img.dataset.etqOrigSizes = img.getAttribute('sizes') || '';
    }
  }

  function applyImage(imgs, url) {
    if (!imgs || !url) return;
    imgs.forEach(function (img) {
      stashOriginal(img);
      // srcset wins over src in the browser's selection — clear it.
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.setAttribute('src', url);
    });
  }

  function revertImage(imgs) {
    if (!imgs) return;
    imgs.forEach(function (img) {
      if (!img.dataset.etqOrigSrc) return;
      img.setAttribute('src', img.dataset.etqOrigSrc);
      if (img.dataset.etqOrigSrcset) img.setAttribute('srcset', img.dataset.etqOrigSrcset);
      if (img.dataset.etqOrigSizes) img.setAttribute('sizes', img.dataset.etqOrigSizes);
    });
  }

  function markSelected(list, dot) {
    list.querySelectorAll('.card__swatch').forEach(function (s) {
      s.classList.remove('is-selected');
    });
    if (dot) dot.classList.add('is-selected');
  }

  // --- TOUCH: tap to swap + lock ---
  function onClick(e) {
    var dot = e.target.closest('.card__swatch');
    if (!dot) return;
    var list = dot.closest('[data-card-swatches]');
    if (!list) return;
    var url = dot.dataset.variantImage;
    if (!url) return;
    applyImage(findCardImages(list), url);
    markSelected(list, dot);
  }

  // --- DESKTOP: hover preview, revert on leave ---
  function onOver(e) {
    var dot = e.target.closest('.card__swatch');
    if (!dot) return;
    var list = dot.closest('[data-card-swatches]');
    if (!list) return;
    var url = dot.dataset.variantImage;
    if (!url) return;
    applyImage(findCardImages(list), url);
    markSelected(list, dot);
  }

  function onLeave(list) {
    if (!list) return;
    revertImage(findCardImages(list));
    markSelected(list, null);
  }

  // Wire both: hover for mouse users, click/tap for touch users.
  document.addEventListener('mouseover', function (e) {
    var dot = e.target.closest('.card__swatch');
    if (dot) onOver(e);
  }, false);

  document.addEventListener('mouseout', function (e) {
    var fromList = e.target.closest('[data-card-swatches]');
    if (!fromList) return;
    var toList = e.relatedTarget ? e.relatedTarget.closest('[data-card-swatches]') : null;
    // Only revert when the pointer leaves this specific row entirely
    if (toList !== fromList) onLeave(fromList);
  }, false);

  document.addEventListener('click', onClick, false);
})();